// extracted by mini-css-extract-plugin
export default {"numericalDropdown":"NumericalDropdown_numericalDropdown__uhRBI","select":"NumericalDropdown_select__gwAg-"};